import { NavLink, Outlet } from "react-router";
import { signOut } from "firebase/auth";
import { CalendarDays, Inbox, LogOut, Pill, Receipt, Settings, Users, Boxes, BarChart3, Globe, ShieldCheck, Stethoscope } from "lucide-react";
import type { Role } from "@cop/domain";
import { Wordmark } from "@cop/ui";
import { auth } from "../lib/firebase";
import { clearSitePreview, ROLE_LABEL, useSession } from "../lib/session";

const NAV: { to: string; label: string; icon: typeof Globe; phase?: string; roles?: Role[] }[] = [
  { to: "/agenda", label: "Agenda", icon: CalendarDays },
  { to: "/solicitudes", label: "Solicitudes", icon: Inbox },
  { to: "/pacientes", label: "Pacientes", icon: Users },
  { to: "/profesionales", label: "Profesionales y agenda", icon: Stethoscope, roles: ["superadmin", "owner", "branch_admin"] },
  { to: "/recetas", label: "Recetas y órdenes", icon: Pill, phase: "Fase 5" },
  { to: "/facturacion", label: "Caja y facturación", icon: Receipt, phase: "Fase 4" },
  { to: "/inventario", label: "Inventario", icon: Boxes, phase: "Fase 6" },
  { to: "/reportes", label: "Reportes", icon: BarChart3, phase: "Fase 6" },
  { to: "/configuracion", label: "Configuración", icon: Settings },
  { to: "/sitio", label: "Sitio público", icon: Globe, roles: ["superadmin", "owner"] },
  { to: "/administradores", label: "Administradores", icon: ShieldCheck, roles: ["superadmin"] },
];

export function Shell() {
  const { user, role } = useSession();
  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <Wordmark />
          <span className="sidebar-app">Admin</span>
        </div>
        <nav aria-label="Secciones">
          {NAV.filter((n) => !n.roles || (role && n.roles.includes(role))).map(({ to, label, icon: Icon, phase }) => (
            <NavLink key={to} to={to} className="nav-item">
              <Icon aria-hidden size={18} strokeWidth={1.5} />
              <span>{label}</span>
              {phase && <span className="nav-phase">{phase}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-user">
          <div>
            <strong>{user?.displayName ?? user?.email}</strong>
            <span>{role ? ROLE_LABEL[role] : ""}</span>
          </div>
          <button type="button" className="icon-btn" onClick={() => (clearSitePreview(), signOut(auth))} aria-label="Cerrar sesión" title="Cerrar sesión">
            <LogOut aria-hidden size={18} strokeWidth={1.5} />
          </button>
        </div>
      </aside>
      <main className="main" id="main">
        <Outlet />
      </main>
    </div>
  );
}
